export default __webpack_public_path__ + "static/media/Shiv of the Autumn Night.4a379068.jpg";